import React from "react";

import LocationIndicator from "components/sub-components/LocationIndicator/LocationIndicator";
import PageContainerComponent from "../../../../../../components/common/page-container-component/PageContainerComponent";
import styles from "./PaymentPage.module.css";
import FloorPlateNavOptions from "components/common/floor-plate-nav-options/FloorPlateNavOptions";
import { Box, Divider } from "@chakra-ui/react";
function PaymentPage() {
  const labels_Values = [
    { label: "Type", value: "Apartment" },
    { label: "View", value: "Side" },
    { label: "Area", value: "130" },
    { label: "Garden", value: "N/A" },
    { label: "Total Area", value: "130" },
    { label: "Cash Price + Parking + Storage", value: "1,774,863" },
    { label: "Maintenance", value: "253,806" },
    { label: "Club House", value: "125,000" },
    { label: "Installment 7 years", value: "2,538,055" },
    { label: "Installment 15% Deposit", value: "380,708" },
    { label: "Installment 7 years", value: "308,192" },
    { label: "Installment Parking", value: "150,000" },
    { label: "Installment Warehouse", value: "N/A" },
    { label: "Status", value: "Available" },
    { label: "Finishing", value: "Core & Shell" },
    { label: "Delivery", value: "Ready To Go" },
  ];
  return (
    <PageContainerComponent>
      <LocationIndicator text="Zone 3 - Type F" fontSize={60} />
      <Box className={styles.paymentContainer}>
        {labels_Values.map((item, index) => (
          <>
            <Box className={styles.paymentColumn} key={index}>
              <Box
                as="p"
                className={styles.paymentColumnLabel}
                fontSize={{
                  tablet7: "1.6rem",
                  tablet16: "3rem",
                }}
              >
                {item.label}
              </Box>
              <Box
                as="p"
                className={styles.paymentColumnValue}
                fontSize={{
                  tablet7: "1.6rem",
                  tablet16: "3rem",
                }}
              >
                {item.value}
              </Box>
            </Box>
            <Divider color="brown" />
          </>
        ))}
      </Box>
      <FloorPlateNavOptions isPaymentPage />
    </PageContainerComponent>
  );
}
export default PaymentPage;
